import React from 'react';
import get from 'lodash/get';

import { cn } from 'helpers/css';
import DateRange from 'components/DateRange';

const propTypes = {};

/**
 *
 * @param {Object} props
 * @returns
 */
const FromToPickerField = (props) => {
  const {
    field,
    form,
    label = '',
    isClearable,
    classNameContainer,
    innerRef,
    afterOnChange,
    disableSelectTime,
    disableSelectMinutes,
    v2,
    required,
  } = props;

  //! State

  const { values } = form;
  const { name } = field;

  const dateRanges = get(values, name);
  const { errors, touched, setFieldValue } = form;

  const msgFromError = get(errors, `${name}.from`);
  const isFromTouched = get(touched, `${name}.from`);

  const msgToError = get(errors, `${name}.to`);
  const isToTouched = get(touched, `${name}.to`);

  //! Effect

  //! Function

  //! Render
  return (
    <div className={cn('component:FromToPickerField', classNameContainer)}>
      <DateRange
        value={dateRanges?.from || dateRanges?.to ? dateRanges : null}
        onSubmit={(dateRange) => {
          setFieldValue(name, dateRange);
          afterOnChange && afterOnChange(dateRange);
        }}
        onClickClear={() => {
          setFieldValue(name, null);
        }}
        innerRef={innerRef}
        label={label}
        isClearable={isClearable}
        msgError={(isFromTouched && msgFromError) || (isToTouched && msgToError)}
        disableSelectTime={disableSelectTime}
        onlyHours={disableSelectMinutes}
        v2={v2}
        required={required}
      />
    </div>
  );
};

FromToPickerField.propTypes = propTypes;
export default FromToPickerField;
